import type * as React from "react";
import { Button, type ButtonProps } from "./button";

type IconSize = "xs" | "sm" | "md" | "lg" | "xl";

export type IconButtonProps = Omit<
  ButtonProps,
  "size" | "prefixIcon" | "suffixIcon"
> & {
  size?: IconSize;
  /** Accessible label for screen readers */
  "aria-label": string;
};

export function IconButton({
  size = "md",
  kind = "ghost",
  variant = "neutral",
  children,
  ...props
}: IconButtonProps) {
  return (
    <Button
      kind={kind}
      variant={variant}
      size={`icon-${size}` as ButtonProps["size"]}
      {...props}
    >
      {children}
    </Button>
  );
}
